module.exports = __webpack_public_path__ + "img/icon-aircon.f3a7bf38.svg";